import { getAllEnums } from '@/api/systemSetting';
import { EnumList } from '@/type/systemSetting';
// 全局共享数据示例
import { useState, useEffect } from 'react';
import { history } from '@umijs/max';
import { getCommonEnumInfo } from '@/api/common';
import { isGlobalEnv } from '@/config';

const useGlobal = () => {
    // 工单枚举
    const [workOrderEnums, setWorkOrderEnums] = useState<EnumList>({});
    const [afterSaleEnumList, setAfterSaleEnumList] = useState<any>();

    const [isFullScreen, setIsFullScreen] = useState<boolean>(false);

    useEffect(() => {
        // 加载工单枚举
        if (
            history.location.pathname !== '/login' &&
            history.location.pathname !== '/skip'
        ) {
            getAllEnums().then((result) => {
                if (result) {
                    setWorkOrderEnums(result);
                }
            });

            // 获取枚举接口的值
            let needInfoList: string =
                'workOrderCloseReasonEnum,aftersaleTypeEnum,aftersaleTypeAllEnum,orderChannelEnum,aftersaleInfoEnum,operateFromTerminalEnum,operateFromEnum,depponOrderStatusEnum,sfOrderRouteStatusEnum,jdOrderStatusEnum,expressStatusEnum,workOrderTagEnum,assignStrategyEnum, workOrderStatusEnum, yesOrNo, workOrderTypeEnum, userLabelEnum,selfBuyChannel,applicationEnum,sessionTypeEnum,upgradeReasonEnum,identityTypeEnum';
            if (isGlobalEnv) {
                needInfoList += ',overseaExpressCompanyEnum';
            }
            getCommonEnumInfo(needInfoList).then((data) => {
                if (data) {
                    // console.log('daga======', data);
                    const orderRouteStatus: any = [];
                    // const orderChannelEnum: any = [];
                    let index = orderRouteStatus.length;
                    data.sfOrderRouteStatusEnum.forEach((item: any) => {
                        orderRouteStatus.push({
                            label: item.value,
                            value: index++,
                            unique: item.index,
                        });
                    });
                    data.jdOrderStatusEnum.forEach((item: any) => {
                        orderRouteStatus.push({
                            label: item.desc,
                            value: index++,
                            unique: item.index,
                        });
                    });
                    data.depponOrderStatusEnum.forEach((item: any) => {
                        orderRouteStatus.push({
                            label: item.value,
                            value: index++,
                            unique: item.index,
                        });
                    });
                    // data.orderChannelEnum.forEach((item: any) => {
                    //     orderChannelEnum.push({
                    //         label: item.mappingValue,
                    //         value: item.index,
                    //     });
                    // });
                    data.orderRouteStatusEnum = orderRouteStatus;
                    // data.orderChannelEnum = orderChannelEnum;
                    setAfterSaleEnumList(data);
                }
            });
        }
    }, []);

    return {
        workOrderEnums,
        afterSaleEnumList,
        isFullScreen,
        setIsFullScreen,
    };
};

export default useGlobal;
